<template>
  <div>
    <div class="row">
      <div class="col-xs-12" v-if="!panel.autofit">
        <div class="form-group">
          <label for>Content Size</label>
          <input type="number" v-model="panel.content.size">
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-group">
          <label for>Content Colour</label>
          <select v-model="panel.content.colour">
            <option value>-- Select Colour --</option>
            <option v-for="(option, index) in colours.arr" :key="index" :value="option.value">{{option.label}}</option>
          </select>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-group">
          <label for>Background Colour</label>
          <select v-model="panel.backgroundColour">
            <option value>-- Select Colour --</option>
            <option v-for="(option, index) in colours.arr" :key="index" :value="option.value">{{option.label}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import colours from "../../../utils/colours";
export default {
  props: ["panel"],
  data() {
    return {
      colours
    };
  }
};
</script>

<style>
</style>
